import { useApiFetcherSWR } from "hooks/SwrCustom";

export const API_ENDPOINT = {
    GET_PERSON_LOGS: {
        url: "person-logs",
        method: "get",
    },
    COMMUNITY_CONTRACT_LIST: {
        url: "get-communities",
        method: "get",
    },
};

export const usePersonLogs = (
    communityName = "Alle besturen",
    platform = "Alle"
) => {

    const params = new URLSearchParams();

    if (communityName && communityName !== "Alle besturen") {
        params.append("search", communityName);
    }

    if (platform && platform !== "Alle") {
        params.append("platform", platform);
    }


    return useApiFetcherSWR({
        ...API_ENDPOINT.GET_PERSON_LOGS,
        url: params.toString()
            ? `person-logs?${params.toString()}`
            : API_ENDPOINT.GET_PERSON_LOGS.url,
    });
};

export const useCommunityContractList = () =>
    useApiFetcherSWR(API_ENDPOINT.COMMUNITY_CONTRACT_LIST);